function iife(fn, ...args) {
  return fn(...args);
}
export {
  iife
};
//# sourceMappingURL=tracing-utils.js.map